export default __webpack_public_path__ + "static/media/challenges-main.65cfdae0.svg";